import { useTranslation } from "react-i18next";
import { AuthForm } from "./AuthForm";

export const Auth = () => {
  const { t } = useTranslation();
  return <AuthForm btnText={t("login.sign_in")} formLocation={"login"} />;
};
